<template>
    <b-modal id="bibModal" :hide-footer="true">
        <div id="bibForm">
			<div class="formTitle">
				<svg-image image="iconBib"/>
				<h5>{{ $t("bib.modal.head") }}</h5>
                <h6>{{ $t("bib.modal.date") }}</h6>
			</div>

            <b-row v-html="$t('bib.modal.step')">
            </b-row>

            <div class="groupLabel"><label>{{ $t("bib.modal.ltnc") }}</label></div>
            <div class="termsConditions" v-html="$t('bib.modal.tnc')">
            </div>
            
            <div class="groupLabel"><label>{{ $t("bib.modal.lform") }}</label></div>
            <b-form>
                <b-form-group id="" :label="$t('bib.modal.fname')" label-for="" :description="$t('bib.modal.fnamedesc')">
                    <b-form-input
                        id="name"
                        required
                        placeholder=""
                        >
                    </b-form-input>
				</b-form-group>
                <b-form-group id="" :label="$t('bib.modal.femail')" label-for="" :description="$t('bib.modal.femaildesc')">
                    <b-form-input
                        id="email"
                        type="email"
                        required
                    >
                    </b-form-input>
				</b-form-group>
                <b-form-checkbox
                    id="acceptance"
                    name="acceptance"
                    value="accepted"
                    unchecked-value="not_accepted"
                    >
                    <div v-html="$t('bib.modal.facceptance')"></div>
				</b-form-checkbox>
                <div class="clearfix">
					<b-button block type="submit" variant="primary" size="lg"><b-spinner small type="grow"></b-spinner> {{ $t("bib.modal.btn") }}</b-button>
				</div>
            </b-form>
        </div>
    </b-modal>
</template>
<script>
import SvgImage from '../components/SvgImage.vue';
export default {
    components : {  
	    SvgImage,
    },
}
</script>


// WEBPACK FOOTER //
// BibModal.vue